"use strict";
const actionTypes = require('../actionTypes');
function auth(authState = {
        // Initial status is ATTEMPT_LOGIN to prevent flash of login button on app start.
        status: actionTypes.ATTEMPT_LOGIN,
    }, action) {
    switch (action.type) {
        case actionTypes.ATTEMPT_LOGIN:
            return {
                requestedProviderId: action.requestedProviderId,
                status: actionTypes.ATTEMPT_LOGIN,
                user: null,
            };
        case actionTypes.ACCOUNT_EXISTS:
            return Object.assign({}, authState, {
                status: actionTypes.ACCOUNT_EXISTS,
                existingProviderId: action.existingProviderId,
            });
        case actionTypes.LOGIN_SUCCESS:
            return {
                existingProviderId: null,
                requestedProviderId: null,
                status: actionTypes.LOGIN_SUCCESS,
                user: action.user,
            };
        case actionTypes.LOGOUT:
            return {
                existingProviderId: null,
                requestedProviderId: null,
                status: actionTypes.LOGOUT,
                user: null,
            };
        default:
            return authState;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = auth;



/** WEBPACK FOOTER **
 ** ./src/reducers/auth.ts
 **/